/** When your routing table is too long, you can split it into small modules**/

let tcaRouters = [
  {
    title: "協會管理系統",
    icon: { icon: "tabler-box" },
    action: "manage",
    subject: "TCA",
    children: [
      {
        title: "計畫項目管理",
        icon: { icon: "tabler-calendar-event" },
        action: "manage",
        subject: "TCA",
        children: [
          {
            title: '計畫項目建立與發佈',
            to: {
              path: '/tca/tnm/ProjectCreationAndPublication',
            },
            action: "manage",
            subject: "PROJECT",
          },
          {
            title: '計畫項目清單(中心)',
            to: {
              path: '/tca/tnm/ProjectListCenter',
            },
            action: "manage",
            subject: "PROJECTLIST",
          },
          {
            title: '計畫項目清單(協會)',
            to: {
              path: '/tca/tnm/PlanProjectListQuery',
            },
            action: "manage",
            subject: "PLANPROJECTLISTQUERY",
          },
          {
            title: '計畫項目時程管理',
            to: {
              path: '/tca/tnm/ProjectScheduleManagement',
            },
            action: "manage",
            subject: "PROJECTSCHEDULE",
          }
        ],
      },
      {
        title: "培訓計畫申請",
        icon: { icon: "tabler-template" },
        action: "manage",
        subject: "TCA",
        children: [
          {
            title: '培訓計畫申請',
            to: {
              path: '/tca/tnm/TrainingPlanApplication',
            },
            action: "manage",
            subject: "TRAININGPLAN",
          },
          {
            title: '培訓計畫申請清單(中心)',
            to: {
              path: '/tca/tnm/TrainingPlanApplicationList',
            },
            action: "manage",
            subject: "TRAININGPLANLIST",
          },
          {
            title: '培訓計畫申請清單(協會)',
            to: {
              path: '/tca/tnm/TrainingPlanApplicationListAssociation',
            },
            action: "manage",
            subject: "TRAININGPLANLISTASSOCIATION",
          }
        ],
      },
      {
        title: "培訓隊名單申請",
        icon: { icon: "tabler-users" },
        action: "manage",
        subject: "TCA",
        children: [
          {
            title: '培訓隊名單申請',
            to: {
              path: '/tca/tnm/TrainingTeamApplication',
            },
            action: "manage",
            subject: "TRAININGTEAM",
          },
          {
            title: '培訓隊名單申請清單(中心)',
            to: {
              path: '/tca/tnm/TrainingApplicationList',
            },
            action: "manage",
            subject: "TRAININGTEAMLIST",
          },
          {
            title: '培訓隊名單申請清單(協會)',
            to: {
              path: '/tca/tnm/TrainingApplicationQueryList',
            },
            action: "manage",
            subject: "TRAININGAPPLICATIONQUERYLIST",
          },
          {
            title: '調訓名單列印',
            to: {
              path: '/tca/tnm/TrainingListPrint',
            },
            action: "manage",
            subject: "TRAININGLISTPRINT",
          }
        ],
      },
      {
        title: "黃金計畫",
        icon: { icon: "tabler-users" },
        action: "manage",
        subject: "TCA",
        children: [
          {
            title: "黃金計畫會議記錄",
            to: {
              path: "/tca/erm/GoldPlanMeetingRecords",
            },
            action: "manage",
            subject: "GOLDPLANMEETINGRECORDS",
          },
          {
            title: "黃金計畫選手清單",
            to: {
              path: "/tca/erm/GoldPlanAthleteList",
            },
            action: "manage",
            subject: "GOLDPLANATHLETELIST",
          },
          {
            title: "黃金計畫申請",
            to: {
              path: "/tca/erm/GoldPlanApply",
            },
            action: "manage",
            subject: "GOLDPLANAPPLY",
          },
          
        ],
      },
      {
        title: "經費需求項目管理",
        icon: { icon: "tabler-calendar-event" },
        action: "manage",
        subject: "TCA",
        children: [
          {
            title: "經費需求項目建立與發佈",
            to: {
              path: "/tca/erm/ExpenseRequestProject",
            },
            action: "manage",
            subject: "EXPENSEREQUESTPROJECT",
          },
          {
            title: "經費需求項目清單(中心)",
            to: {
              path: "/tca/erm/ExpenseRequestProjectCenterList",
            },
            action: "manage",
            subject: "EXPENSEREQUESTPROJECTCELIST",
          },
          {
            title: "經費需求項目清單(協會)",
            to: {
              path: "/tca/erm/ExpenseRequestProjectList",
            },
            action: "manage",
            subject: "EXPENSEREQUESTPROJECTLIST",
          }
        ],
      },
      {
        title: "經費預算申請",
        icon: { icon: "tabler-template" },
        action: "manage",
        subject: "TCA",
        children: [
          {
            title: "經費預算申請",
            to: {
              path: "/tca/erm/ExpenseRequest",
            },
            action: "manage",
            subject: "EXPENSEREQUEST",
          },
          
          {
            title: "經費預算申請清單(中心)",
            to: {
              path: "/tca/erm/ExpenseRequestCenterList",
            },
            action: "manage",
            subject: "EXPENSEREQUESTCENTERLIST",
          },
          {
            title: "經費預算申請清單(協會)",
            to: {
              path: "/tca/erm/ExpenseRequestList",
            },
            action: "manage",
            subject: "EXPENSEREQUESTLIST",
          },
          
        ],
      },
      {
        title: "經費核銷申請",
        icon: { icon: "tabler-coin" },
        action: "manage",
        subject: "TCA",
        children: [
          {
            title: "經費核銷申請",
            to: {
              path: "/tca/erm/ExpenseReimbursement",
            },
            action: "manage",
            subject: "EXPENSEREIMBURSEMENT",
          },
          {
            title: "經費核銷申請清單(中心)",
            to: {
              path: "/tca/erm/ExpenseReimbursementCenterList",
            },
            action: "manage",
            subject: "EXPENSEREIMBURSEMENTCELIST",
          },
          {
            title: "經費核銷申請清單(協會)",
            to: {
              path: "/tca/erm/ExpenseReimbursementList",
            },
            action: "manage",
            subject: "EXPENSEREIMBURSEMENTLIST",
          },
          {
            title: "上傳憑證",
            to: {
              path: "/tca/erm/PaymentVoucherUpload",
            },
            action: "manage",
            subject: "PAYMENTVOUCHERUPLOAD",
          },
          {
            title: "憑證確認",
            to: {
              path: "/tca/erm/PaymentVoucherConfirm",
            },
            action: "manage",
            subject: "PAYMENTVOUCHERCONFIRM",
          },
          {
            title: "年度經費核銷總表",
            to: {
              path: "/tca/erm/AnnualExpenseSummary",
            },
            action: "manage",
            subject: "ANNUALEXPENSESUMMARY",
          },
          {
            title: "各協會經費核結統計",
            to: {
              path: "/tca/erm/AssociationBudgetExpense",
            },
            action: "manage",
            subject: "ASSOCIATIONBUDGETEXPENSE",
          },
          {
            title: "經費需求申請期程",
            to: {
              path: "/tca/erm/AssociationBudgetSchedule",
            },
            action: "manage",
            subject: "ASSOCIATIONBUDGETSCHEDULE",
          },
        ],
      },
      {
        title: "經費計畫變更申請",
        icon: { icon: "tabler-calendar-plus" },
        action: "manage",
        subject: "TCA",
        children: [
          {
            title: "經費計畫變更行程申請",
            to: {
              path: "/tca/erm/ExpenseChangeSchedule",
            },
            action: "manage",
            subject: "EXPENSECHANGESCHEDULE",
          },
          {
            title: "經費計畫變更申請",
            to: {
              path: "/tca/erm/ExpenseChange",
            },
            action: "manage",
            subject: "EXPENSECHANGE",
          },
          {
            title: "經費計畫變更清單(中心)",
            to: {
              path: "/tca/erm/ExpenseChangeCenterList",
            },
            action: "manage",
            subject: "EXPENSECHANGECENTERLIST",
          },
          {
            title: "經費計畫變更清單(協會)",
            to: {
              path: "/tca/erm/ExpenseChangeList",
            },
            action: "manage",
            subject: "EXPENSECHANGELIST",
          }
        ],
      },
      {
        title: "經費預借申請",
        icon: { icon: "tabler-mood-dollar" },
        action: "manage",
        subject: "TCA",
        children: [
          {
            title: "經費預借申請",
            to: {
              path: "/tca/erm/ExpenseBorrow",
            },
            action: "manage",
            subject: "EXPENSEBORROW",
          },
          {
            title: "經費預借申請清單(中心)",
            to: {
              path: "/tca/erm/ExpenseBorrowCenterList",
            },
            action: "manage",
            subject: "EXPENSEBORROWCENTERLIST",
          },
          {
            title: "經費預借申請清單(協會)",
            to: {
              path: "/tca/erm/ExpenseBorrowList",
            },
            action: "manage",
            subject: "EXPENSEBORROWLIST",
          }
        ],
      },
      {
        title: "協會管理基本設定",
        icon: { icon: "tabler-settings" },
        action: "manage",
        subject: "TCA",
        children: [
          {
            title: '競技處各協會輔導員設定',
            to: {
              path: '/tca/tnm/AssociationCounselorSettings',
            },
            action: "manage",
            subject: "COUNSELOR",
          },
          {
            title: '財務室各協會輔導員設定',
            to: {
              path: '/tca/tnm/FnAssociationCounselorSettings',
            },
            action: "manage",
            subject: "FNCOUNSELOR",
          },
          {
            title: '國外出差生活費日支數額',
            to: {
              path: '/tca/tnm/ExpensePerDiem',
            },
            action: "manage",
            subject: "EXPENSEPERDIEM",
          },
          {
            title: '國外國家地區代碼維護',
            to: {
              path: '/tca/tnm/CountryAreaCode',
            },
            action: "manage",
            subject: "COUNTRYAREACODE",
          },
          {
            title: '國內外參賽及移訓核銷項目',
            to: {
              path: '/tca/tnm/ReimburseItem',
            },
            action: "manage",
            subject: "REIMBURSEITEM",
          }
        ],
      },
      {
        title: "轉派作業",
        icon: { icon: "tabler-calendar-plus" },
        action: "manage",
        subject: "TCA",
        children: [
          {
            title: "經費預算申請轉派作業",
            to: {
              path: "/tca/erm/ExpenseRequestReassign",
            },
            action: "manage",
            subject: "EXPENSEREQUESTREASSIGN",
          },
          {
            title: "經費計畫變更申請轉派作業",
            to: {
              path: "/tca/erm/ExpenseChangeReassign",
            },
            action: "manage",
            subject: "EXPENSECHANGEREASSIGN",
          },
          {
            title: "經費核銷申請轉派作業",
            to: {
              path: "/tca/erm/ExpenseReimbursementReassign",
            },
            action: "manage",
            subject: "EXPENSEREIMBURSEMENTREASSIGN",
          }
        ],
      }
    ],
  },
];
export default tcaRouters;
